module.exports = __webpack_public_path__ + "img/thumbnail_RedCrownedCrane_m_normal.8ddc3d61.png";